import { render, staticRenderFns } from "./addBookToItemForm.vue?vue&type=template&id=235086ae&scoped=true&"
import script from "./addBookToItemForm.vue?vue&type=script&lang=js&"
export * from "./addBookToItemForm.vue?vue&type=script&lang=js&"
import style0 from "./addBookToItemForm.vue?vue&type=style&index=0&id=235086ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235086ae",
  null
  
)

export default component.exports